var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showNextEvent)?_c('div',{class:_vm.$style.eventContainer},[_c('ParagraphBody',{class:_vm.$style.eventText,attrs:{"bodySize":"small","data-test-id":"NextScheduledEvent__event"}},[_vm._v(" "+_vm._s(_vm.getText)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }